import { useEffect,useState } from 'react';
import QuickReply from './QuickReply/QuickReply';
import { useChatboxDispatchContext, useChatboxStateContext } from "../../../context/ChatboxContext";
import { useConversationStateContext } from "../../../context/ConversationContext";

function ChatContainerQuickReply() {
    const dispatch = useChatboxDispatchContext();

    const { data } = useConversationStateContext();
    const { responses, messages } = data;

    var quickreplies = responses.filter(response => response.type == 'quick');
    quickreplies = quickreplies.map(quickreplie => quickreplie.content.split('\\').map((str,index) => {return {...quickreplie, content : str.trim(), key : `${quickreplie.tracking}_${index}`}}))
    if(quickreplies.length) {
        quickreplies = quickreplies.reduce((res, el) => res.concat(el));
    } 
    quickreplies = [...quickreplies, ...responses.filter(response => response.type == 'raw' && response.content?.context == 'dial_action').map(response => {return {...response, content : response.content.values.phoneNumber}})];

    const hiddenQuick = () => {
        dispatch({ type: "openReply" });
        dispatch({ type: "toggleInput" });
    }
    const index = messages.findIndex(message => message.view == 0)
    const [contentHeight, setContentHeight] = useState(0);
    useEffect(() => {
        const quickrepliess = document.querySelector(".kwalys-chatbox-window .kwalys-chat .quickreplies");
        const checkHeight = () => {
          if (quickrepliess) {
            const newContentHeight = quickrepliess.scrollHeight;
            if (newContentHeight > 350) {
              quickrepliess.style.maxHeight = "500px";
              quickrepliess.style.minHeight = "300px";
              quickrepliess.style.overflowY = "auto";
              quickrepliess.classList.add('scrollbar-chatbox');
            } else {
              quickrepliess.style.maxHeight = "";
              quickrepliess.style.minHeight = "";
              quickrepliess.style.overflowY = "";
            }
            setContentHeight(newContentHeight);
          }
        };

        checkHeight();

        const interval = setInterval(checkHeight, 0); // Vérifie toutes les 1 seconde
        return () => clearInterval(interval);
      }, []);

    return (
        <div className={index == -1 && quickreplies.length ? "quickreplies" : "quickreplies invisible"} onClick={hiddenQuick}>
            {quickreplies && quickreplies.map((response) => response.content.trim() ? <QuickReply {...response} key={response.key ?? response.tracking}/> : '')}
        </div>
    );
}

export default ChatContainerQuickReply;